import ErrorPage from "src/pages/error/error-page"
import Welcome from "src/pages/patient/Welcome";

const PatientRoutes = {
    path: "/patient/:id",
    element:<Welcome />,
    errorElement: <ErrorPage />
  }

  export default PatientRoutes